/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_IntervalInputs */

const en__field_interval = /** @type {(inputs: _Field_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`interval`)
};

const de__field_interval = /** @type {(inputs: _Field_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval`)
};

/**
* | output |
* | --- |
* | "interval" |
*
* @param {_Field_IntervalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_interval = /** @type {((inputs?: _Field_IntervalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_IntervalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_interval(inputs)
	return de__field_interval(inputs)
});